import {AdminRole} from 'Common/permissions/AdminRole';
import {ArtistRole} from 'Common/permissions/ArtistRole';
import {PublicRole} from 'Common/permissions/PublicRole';
import {Roles} from 'Common/permissions/Roles';
import {VenueRole} from 'Common/permissions/VenueRole';
import { Role as ConfigRole } from 'Common/config/Role';
import {Role} from 'Common/permissions/Role';
import {BrowserOrServerId} from 'Browser/BrowserId';

export class RolesLoader
{
	createRoles<Id extends BrowserOrServerId>(config:ConfigRole<Id>[]): Roles<Id>
	{
		const roles:Role<Id>[] = [new PublicRole<Id>()];

		for (const role of config) {
			switch(role.type) {
				case 'admin': 
					roles.push(new AdminRole<Id>());
					break;

				case 'public': 
					break;

				case 'artistAdmin': 
					roles.push(new ArtistRole<Id>(role));
					break;

				case 'venueAdmin': 
				case 'venueBareAdmin': 
				case 'venueEventAdmin': 
				case 'venueMenuAdmin': 
				case 'venueDeveloper': 
					roles.push(new VenueRole<Id>(role));
					break;
			}
		}

		return new Roles(roles);
	}
}

